import { useInjection } from 'inversify-react'
import { UserStore } from 'store/user'

import T from '../../config/inversify.types'

export function useUserStore(): UserStore {
    return useInjection<UserStore>(T.UserStore)
}
